import { login as loginApi } from '@/api/login'
import { getUserInfo as getUserInfoApi } from '@/api/user'
import { resetLoginExpiredGate } from '@/utils/loginExpiredGate'

const state = {
  token: localStorage.getItem('token') || '',
  userInfo: JSON.parse(localStorage.getItem('userInfo') || 'null'),
  isLogin: !!localStorage.getItem('token')
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
    state.isLogin = !!token
    if (token) {
      localStorage.setItem('token', token)
    } else {
      localStorage.removeItem('token')
    }
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
    if (userInfo) {
      localStorage.setItem('userInfo', JSON.stringify(userInfo))
    } else {
      localStorage.removeItem('userInfo')
    }
  },
  CLEAR_USER(state) {
    state.token = ''
    state.userInfo = null
    state.isLogin = false
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
  }
}

const actions = {
  // // 登录
  async login({ commit }, loginData) {
    try {
      // 如果已经传入 token 和 userInfo（验证码登录的情况），直接使用
      if (loginData.token && loginData.userInfo) {
        commit('SET_TOKEN', loginData.token)
        commit('SET_USER_INFO', loginData.userInfo)
        resetLoginExpiredGate()

        if (loginData.remember) {
          localStorage.setItem('rememberedPhone', loginData.phone)
        } else {
          localStorage.removeItem('rememberedPhone')
        }
        
        return Promise.resolve({ code: 200, success: true })
      }
      
      // 密码登录，调用 API
      const response = await loginApi(loginData)
      if (response.code == 1) {
        const userinfo  = response.data
          console.log('userinfo', userinfo);
          
        commit('SET_TOKEN', userinfo.token)
        commit('SET_USER_INFO', userinfo.userVo)
        resetLoginExpiredGate()

        // 如果选择记住账号，保存手机号
        if (loginData.remember) {
          localStorage.setItem('rememberedPhone', loginData.phone)
        } else {
          localStorage.removeItem('rememberedPhone')
        }
        
        return Promise.resolve(response)
      } else {
        return Promise.reject(new Error(response.message || '登录失败'))
      }
    } catch (error) {
      return Promise.reject(error)
    }
  },
  
  // 登出
  logout({ commit }) {
    commit('CLEAR_USER')
  },
  
  // 获取用户信息
}

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  isLogin: state => state.isLogin
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

